var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShells(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.39 244.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M88.36,76.33l-54-53-.48,94.25C44.77,99.12,64.25,84.35,88.36,76.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M226.55,118.44l-.49-95.1L171.9,76.45C196.2,84.62,215.78,99.67,226.55,118.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1b2d3b"
    },
    d: "M130,82.2c-49.27,0-89.21,31-89.21,69.29S80.68,220.78,130,220.78s89.21-31,89.21-69.29S179.22,82.2,130,82.2Zm-31,69.29a19.3,19.3,0,1,1,19.29-19.29A19.29,19.29,0,0,1,98.93,151.49Zm62,0a19.3,19.3,0,1,1,19.29-19.29A19.29,19.29,0,0,1,161,151.49Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShells);
export default __webpack_public_path__ + "static/media/shells.7ab00be14de3d2cc9b63f7df6fb4e3fc.svg";
export { ForwardRef as ReactComponent };